import { useState } from 'react';
import { Button, Icon } from '~/components/shared';
import { ProductBundle, ProductWithBundleId } from '~/models/CampaignModel';
import { useBasket } from '../useBasket';

/**
 * Button to show under closed/visible bundle when there is a subsequent bundle in group
 */
export const ProductBundleNextRowButton: React.FC<{ label: string; group: ProductBundle<ProductWithBundleId>[] }> = ({ label, group }) => {
  const groupIds = group.map((g) => g.id);
  const [iconColor, setIconColor] = useState('#000000');
  const openBundle = useBasket((s) => s.openBundle);
  const showBundle = useBasket((s) => s.showBundle);
  const setActiveBundle = useBasket((s) => s.setActiveBundle);
  const bundleVisibility = useBasket((s) => s.bundleVisibility);
  const hasSelectedInGroup = useBasket((s) => s.selectedProducts).some((p) => groupIds.some((g) => p.bundleId === g));
  if (!hasSelectedInGroup) {
    return null;
  }

  const nonVisibleGroup = Object.entries(bundleVisibility)
    .filter(([k]) => groupIds.includes(k))
    .find(([_, v]) => !v.isVisible)?.[0];
  if (!nonVisibleGroup) {
    return null;
  }

  const showNextRow = () => {
    openBundle(nonVisibleGroup, true);
    showBundle(nonVisibleGroup, true);
    setActiveBundle(group.flatMap((g) => g.offers)[0].productType, nonVisibleGroup);
  };

  return (
    <Button
      type="secondary"
      className="next-row-button"
      onClick={showNextRow}
      iconMargin="right"
      onMouseEnter={() => setIconColor('#FFFFFF')}
      onMouseLeave={() => setIconColor('#000000')}
    >
      <Icon type="plus" fill={iconColor} size={1.5} />
      {label}
    </Button>
  );
};
